import { render, staticRenderFns } from "./CoverageDropdown.vue?vue&type=template&id=56107726&scoped=true&"
import script from "./CoverageDropdown.vue?vue&type=script&lang=js&"
export * from "./CoverageDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56107726",
  null
  
)

export default component.exports